import { render } from "./email_form.vue?vue&type=template&id=738d597e"
import script from "./email_form.vue?vue&type=script&lang=js"
export * from "./email_form.vue?vue&type=script&lang=js"
script.render = render

export default script